import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import type { ChecklistRescheduleInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-reschedule.dto';
import type { ChecklistFindInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-find.dto';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import type { EventCalendarItemFindInterface } from '@zaoblako/shared/modules/report/dtos/event-calendar/event-calendar-item-find.dto';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { ProjectChecklistService } from '@zaoblako/web/core/services/project/project-checklist.service';
import { ProjectService } from '@zaoblako/web/core/services/project/project.service';
import { ChecklistRescheduleFormComponent } from '@zaoblako/web/modules/project/dumbs/checklist-reschedule-form/checklist-reschedule-form.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'crm-checklist-reschedule',
  standalone: true,
  imports: [CommonModule, SpinnerComponent, ChecklistRescheduleFormComponent],
  templateUrl: './checklist-reschedule.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChecklistRescheduleComponent implements OnInit {
  public saving = false;
  public checklist: ChecklistFindInterface;
  public info = <ChecklistRescheduleInterface>{};
  public isExtendTime: boolean;

  public checklistId: number;
  public projectId: number;
  public project: ProjectFindInterface;

  public constructor(
    private readonly projectChecklistService: ProjectChecklistService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly projectService: ProjectService
  ) {
    this.checklist = this.config.data?.checklist;
    this.isExtendTime = this.config.data?.isExtendTime;

    this.checklistId = this.config.data?.checklistId;
    this.projectId = this.config.data?.projectId;

    const eventCalendar: EventCalendarItemFindInterface = this.config.data?.eventCalendar;

    if (eventCalendar) {
      this.info.startAt = eventCalendar.date;
      this.info.endAt = eventCalendar.endDate;
    }

    if (this.checklist) {
      this.info.startAt = this.checklist.startAt;
      this.info.endAt = this.checklist.endAt;
    }
  }

  public ngOnInit(): void {
    if (this.checklistId) {
      forkJoin([
        this.projectChecklistService.findById<ChecklistFindInterface>(this.checklistId),
        this.projectService.findById<ProjectFindInterface>(this.projectId)
      ]).subscribe(([checklist, project]) => {
        this.checklist = checklist;
        this.project = project;
        this.cdRef.markForCheck();
      });
    }
  }

  public save(info: ChecklistRescheduleInterface) {
    this.saving = true;
    this.cdRef.markForCheck();

    this.projectChecklistService.reschedule(this.checklist.id, info).subscribe({
      next: () => {
        this.saving = false;
        this.cdRef.markForCheck();
        this.errorService.addSuccessMessage(
          this.isExtendTime
            ? `Окончание события ${this.checklist.name} продлено`
            : `Событие ${this.checklist.name} перенесено`
        );
        this.checklist.startAt = info.startAt;
        this.checklist.endAt = info.endAt;
        this.ref.close(this.checklist);
      },
      error: () => {
        this.saving = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
